import {
	SET_USERAPPSETTINGS_STATE
} from './actions';

let defaultState = {
    userAppSettings: {
        showDialog: false
    }
};

export default function inbox(state = defaultState, action) {
	switch (action.type) {
		case SET_USERAPPSETTINGS_STATE:
			return {
				...state,
				userAppSettings: action.data
			};
		default:
			return state;
	}
}
